import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {GENDERS, LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode, USER_ROLE_LIST} from "@app/constants/Common";
import {
    requestSaveUser,
    requestSaveEndPriDate,
    requestGetUserList,
    requestGetUserEmailList, requestSaveUserEmail
} from "@app/services/UserService";
import DatePicker from "react-datepicker";
import Select from "react-select";
import {cloneDeep} from "lodash";
import {alertMessage} from "@app/constants/Messages";
import UserEmailListTable from "@pages/user/UserEmailListTable";

const UserEmailsModal = (props) => {
    const {isShow, userId, onClose} = props



    return (
        <>
            <Modal show={isShow}
                   size={'lg'}
                   onHide={() => onClose()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>{"User emails - User ID: "} {userId}</Modal.Title>
                    <Button variant='secondary' onClick={() => onClose()}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <UserEmailListTable userId={userId}/>
                </Modal.Body>
                {/*<Modal.Footer>*/}
                {/*    */}
                {/*</Modal.Footer>*/}
            </Modal>
        </>
    )
}

export default UserEmailsModal;
